var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.filters,"label":_vm.label || _vm.$t('common.filters'),"loading":_vm.filtersPending,"disabled":_vm.disabled,"name":_vm.name,"item-text":"name","item-value":"_id","hide-details":"","clearable":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }